(() => {
  const root = document.querySelector(".hl-coming-soon");
  if (!root || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const benefits = root.querySelector(".hl-coming-soon__benefits");
  if (!benefits) return;

  const easing = 0.12;
  const target = { x: 0, y: 0 };
  const current = { x: 0, y: 0 };
  let frame = null;

  const render = () => {
    current.x += (target.x - current.x) * easing;
    current.y += (target.y - current.y) * easing;
    benefits.style.setProperty("--pointer-x", current.x.toFixed(3));
    benefits.style.setProperty("--pointer-y", current.y.toFixed(3));

    if (Math.abs(target.x - current.x) > 0.001 || Math.abs(target.y - current.y) > 0.001) {
      frame = requestAnimationFrame(render);
    } else {
      current.x = target.x;
      current.y = target.y;
      frame = null;
    }
  };

  const scheduleRender = () => {
    if (frame === null) frame = requestAnimationFrame(render);
  };

  const updatePointer = (event) => {
    const bounds = benefits.getBoundingClientRect();
    target.x = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width) * 2 - 1));
    target.y = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height) * 2 - 1));
    scheduleRender();
  };

  const resetPointer = () => {
    target.x = 0;
    target.y = 0;
    scheduleRender();
  };

  benefits.addEventListener("pointermove", updatePointer, { passive: true });
  benefits.addEventListener("pointerleave", resetPointer, { passive: true });
})();
